import { h } from 'vue'
import UiComponentContainer from '~ui/components/container/container.vue'
import UiComponentHeading from '~ui/components/heading/heading.vue'
import UiComponentWrapper from '~ui/components/wrapper/wrapper.vue'

const Functional = (props) => {
  return h(
    UiComponentWrapper,
    { class: 'end-to-end' },
    () => [
      h(UiComponentContainer, { class: 'inner' }, () => [
        h(UiComponentWrapper, { class: 'head' }, () => [
          h(
            UiComponentHeading,
            { level: 2 },
            () => props.record.title || props.componentEndToEnd.title,
          ),
          h(UiComponentWrapper, { class: 'navigation' }, () => [
            h(UiComponentWrapper, { class: 'cursor' }, () => [
              h(UiComponentWrapper, { class: 'progress' }),
            ]),
            props.componentEndToEnd.steps.map(({ id, title }, index) =>
              h(
                UiComponentWrapper,
                {
                  key: `end-to-end-nav-item-${id}`,
                  class: [
                    'item',
                    { active: props.endToEndActiveIndex === index },
                  ],
                  onClick: () => {
                    props.callback(index)
                  },
                },
                () => title,
              ),
            ),
          ]),
        ]),
        h(UiComponentWrapper, { class: 'body' }, () => [
          h(UiComponentWrapper, { class: 'slider' }, () => [
            props.componentEndToEnd.steps.map(
              ({ id, backgroundVideo, iconVideo }) =>
                h(
                  UiComponentWrapper,
                  {
                    key: `end-to-end-slider-${id}`,
                    class: 'item',
                  },
                  () => [
                    h('video', {
                      'class': 'background',
                      'data-background': 'true',
                      'muted': true,
                      'src': backgroundVideo.asset.mp4Url,
                    }),
                    h(
                      'video',
                      {
                        muted: true,
                      },
                      () => [
                        h('source', {
                          src: iconVideo[0].forSafariHevcFormat.url,
                          type: `video/mp4; codecs="hvc1"`,
                        }),
                        h('source', {
                          src: iconVideo[0].forChromeVp9Format.url,
                          type: 'video/webm',
                        }),
                      ],
                    ),
                  ],
                ),
            ),
          ]),
        ]),
      ]),
    ],
  )
}

Functional.props = {
  callback: {
    required: true,
    type: Function,
  },
  componentEndToEnd: {
    required: true,
    type: Object,
  },
  endToEndActiveIndex: {
    required: true,
    type: Number,
  },
  record: {
    required: true,
    type: Object,
  },
}

export default Functional
